import { render } from "./WomanDoctor.vue?vue&type=template&id=0c5f3d80&scoped=true"
import script from "./WomanDoctor.vue?vue&type=script&lang=js"
export * from "./WomanDoctor.vue?vue&type=script&lang=js"

import "./WomanDoctor.vue?vue&type=style&index=0&id=0c5f3d80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5f3d80"]])

export default __exports__